import { Utilities } from '../utilities';
export const questionnaireEvaluationOutcomeSuccessReducer = (state, action) => {
    const getScore = (selectedAction) => {
        if (selectedAction.payload.questionnrVersionList &&
            selectedAction.payload.questionnrVersionList[0].qstnnreEvalOutcomeList &&
            selectedAction.payload.questionnrVersionList[0].qstnnreEvalOutcomeList.length) {
            if (parseInt(selectedAction.payload.questionnrVersionList[0].qstnnreEvalOutcomeList[0].score) === 0) {
                return Utilities.convertToLocale('0.00');
            }
            else {
                return Utilities.convertToLocale(action.payload.questionnrVersionList[0].qstnnreEvalOutcomeList[0].score);
            }
        }
        else {
            return '';
        }
    };
    return Object.assign(Object.assign({}, state), { scoreData: {
            score: getScore(action),
            comment: action.payload.questionnrVersionList &&
                action.payload.questionnrVersionList[0].qstnnreEvalOutcomeList &&
                action.payload.questionnrVersionList[0].qstnnreEvalOutcomeList.length &&
                action.payload.questionnrVersionList[0].qstnnreEvalOutcomeList[0].indicator
                ? action.payload.questionnrVersionList[0].qstnnreEvalOutcomeList[0].indicator
                : ''
        }, overrideScore: action.payload.questionnrVersionList &&
            action.payload.questionnrVersionList.length &&
            action.payload.questionnrVersionList[0].scoreOverride
            ? action.payload.questionnrVersionList[0].scoreOverride
            : null });
};
//# sourceMappingURL=questionnaireEvaluationOutcomeSuccessReducer.js.map